import React, { Component } from 'react'


const MINS = 60000

class Calculator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hourlyRate: 30,
      distractionsPerDay: 5
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    const key = event.target.name
    const value =   Number(event.target.value)
    event.target.value = "";
    if (isNaN(value))
      return
    this.setState({[key]: value})
  }

  render() {
    const { hourlyRate, distractionsPerDay } = this.state
    const lostHoursPerMonth = distractionsPerDay * 30 /* DAYS */ *
      (24 * MINS) / (60 * MINS)
    const lost$PerMonth = hourlyRate * lostHoursPerMonth
    const returnOnInvestment = lost$PerMonth / 10
    const disabled = lost$PerMonth === 0;
    return (
      <div>
      <div className={'row'}>
        <div className={'col-lg-4 col-md-4 col-xs-12'}>
          <span className={'calculator__currency col-xs-12'}>$
            <input  name="hourlyRate" onChange={this.handleChange} onClick={this.handleClick} value={this.state.hourlyRate}/>
          </span>
          <br />
          <p>Hourly rate (or equivalent)</p>
        </div>
        <div className={'col-lg-4 col-md-4 col-xs-12 '}>
          <input className={'calculator__input col-xs-12'}  name="distractionsPerDay" onChange={this.handleChange} onClick={this.handleClick} value={this.state.distractionsPerDay} />
          <br/>
          <p>Distractions per day</p>
        </div>
        
        <div className={'col-lg-4 col-md-4 col-xs-12'}>
          <div className={'calculator__hours col-xs-12'} >{lostHoursPerMonth} hrs</div>
          <br/>
          <h4 className={'h--pink'}>
            <p>
              <b>Productive time lost per month</b>
            </p>
          </h4>
        </div>
      </div>
      <br />
      <div className={'row'}>
        <div className={'col-lg-12 text-center'}>
          <h4 className={disabled?'h--disabled':'h--pink'}><b>Losing focus is costing you </b></h4>
          <div className={'calculator__result'}>
            <b className={disabled?'h--disabled':'h--pink'} >${lost$PerMonth}</b>
          </div>
          <h4 className={disabled?'h--disabled':'h--pink'}><b>every month</b> </h4>

          <h3 className={disabled?'h--disabled':''}>
            You could get a {returnOnInvestment}x return on Focuster by accomplishing <br/>your most important work.
          </h3>
          <a className={'btn btn-calculator'} href="https://next.focuster.com" role="button" >
            START FREE TRIAL
          </a>
        </div>
      </div>
      </div>
    )
  }
}

export default Calculator



// WEBPACK FOOTER //
// ./src/Calculator.js